import React, { FunctionComponent, useEffect } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';

import { loadEmployee } from '../employees/actions/load-employee';
import { userSelector } from '../reducers/current-user-selectors';
import { employeeSelector } from '../reducers/employee-selectors';

import { jobApplicationPageRoute } from '../web-routes';

import { LOGO_ONLY_GRAY_PATH } from '../config/logo-config';
import { HIRING_PERMISSION } from '../util/permissions';

const styles = () =>
  createStyles({
    chip: {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    chipAvatar: {
      width: '20px',
      height: 'auto',
    },
  });

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  employee: employeeSelector(state, ownProps.employeeId),
  user: userSelector(state),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadEmployee: () => dispatch(loadEmployee(ownProps.employeeId)),
  },
});

type InputProps = {
  employeeId: number;
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps & WithStyles<typeof styles>;

const EmployeeTeamEngineBadgeComponent: FunctionComponent<Props> = ({
  employee,
  user,
  actions,
  classes,
}: Props) => {
  useEffect(() => {
    actions.loadEmployee();
  });

  if (!employee || !user) {
    return null;
  }
  if (!employee.jobApplicantId) {
    return null;
  }

  const chip = (
    <Chip
      avatar={
        <Avatar
          className={classes.chipAvatar}
          alt="Hired from Team Engine"
          src={LOGO_ONLY_GRAY_PATH}
        />
      }
      variant="outlined"
      label="from Team Engine"
      className={classes.chip}
    />
  );

  return user.hiringPermission !== HIRING_PERMISSION.NONE ? (
    <Link to={jobApplicationPageRoute(employee.jobApplicantId)} target="_blank">
      {chip}
    </Link>
  ) : (
    chip
  );
};

export const EmployeeTeamEngineBadge = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeTeamEngineBadgeComponent),
);
